import React from "react";
import $ from "jquery";

var slideInterval = 10 * 1000; // 10s
function slideRight(carousel) {
	var item_width = carousel.find("li").outerWidth();
	var left_indent = parseInt(carousel.css("left")) - item_width;

	// make the sliding effect using jQuery's animate function... '
	carousel.not(":animated")
		.animate(
			{"left" : left_indent}, 1000, function() {
				/* when the animation finishes use the if statement again, and make an ilussion
				of infinity by changing place of last or first item */
				// ...and if it slided to right we put the first item after the last item
				carousel.children("li:last").after(carousel.children("li:first"));
				// ...and then just get back the default left indent
				carousel.css({"left" : "-200px"});
			}
		);
}

var date = new Date();

export default class MarqueeArea extends React.Component {
	componentDidMount() {
		var carousel = $(this.refs.marqeeArea).find("#carousel");
		function defineTimer() {
			var timer = setInterval(() => {
				date = new Date();
				slideRight(carousel);
			}, slideInterval);
			return timer;
		}
		var timer = defineTimer();

		carousel.hover(function() {
			// stop the interval
			clearInterval(timer);
		}, function() {
			// and when mouseout start it again
			timer = defineTimer();
		});
	}
	render() {
		return (
			<li ref="marqeeArea" className="marqee-area">
				<ul id="carousel">
					<li>{date.toTimeString()}</li>
					<li>NSE sparkline here</li>
					<li>BSE sparkline here</li>
					<li>Fav Stock #1</li>
				</ul>
			</li>
		);
	}
}


/** WEBPACK FOOTER **
 ** ./src/scripts/components/header/MarqueeArea.jsx
 **/